import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IssueTransactionService } from '../services/issue-transaction.service';

@Pipe({
  name: 'issueTransaction'
})
export class IssueTransactionPipe implements PipeTransform {

  constructor(private _issueTransactionService: IssueTransactionService){ }

  transform(value: string): Observable<string> {
    return this._issueTransactionService.getIssueTransactionById(value, true).pipe(map(x => x.name));
  }

}
